jQuery(document).ready(function($){
    $('.search-form-parent').on('click', '.search-button', function(){
        $(this).closest('.search-form-parent').addClass('is-deployed');
        $(this).closest('.search-form-parent').find('.search-form__input').focus();
    });
    $('.search-form-parent').on('click', '[data-action=submit-form]', function () {
        $(this).closest('form').submit();
    });
    $('.search-form-parent').on('click', '[data-action=close]', function () {
        $(this).closest('.search-form-parent').removeClass('is-deployed');
    });
});